<template>
  <div class="grid-view parent-wrapper">
    <!--<div v-if="$store.getters.enableFrontEndPlugin">
      <micro-app
        name="child-finance-charge-share-modify"
        :url="$store.getters.frontEndPluginUrl+'/financeChargeShareModifyItem'"
        router-mode="pure"
        destroy
        @datachange="financeChargeShareModifyDataChange"
      />
    </div>-->
    <!--  todo: config-module  -->
    <!--    <div class="app-main-page parent-wrapper">-->
    <!--      <div v-show="pageMode===0" style="display: flex;flex:1">-->
    <query-charge
      v-show="pageMode===0 && searchConditions.writeOffMode===1"
      key="queryCharge"
      ref="queryCharge"
      :is-append-query="true"
      identify="queryChargeSearchItem"
      view-source="Writeoff"
      :is-ar="searchConditions.isAr"
      :paid-off="searchConditions.paidOff"
      :oversea="searchConditions.isOversea"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      :writeoff-has-invoice="searchConditions.writeoffHasInvoice"
      :invoice-has-bill-payment="searchConditions.invoiceHasBillPayment"
      config-module="5021"
      grid-config-module="190701"
      :show-invoice-no="true"
      :show-billing-no="true"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :show-inco-term="true"
      :internal-charge="searchConditions.internalCharge"
      :show-wht="true"
      type="both"
      total-type="auto"
      job-state-param="WriteoffJobState"
      charge-state-param="WriteoffChargeState"
      confirm-state-param="WriteoffChargeConfirmState"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===0 && searchConditions.writeOffMode===1"
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-charge>
    <query-invoice
      v-show="pageMode===0 && searchConditions.writeOffMode===2"
      key="queryInvoice"
      ref="queryInvoice"
      :is-append-query="true"
      identify="queryInvoiceSearchItem"
      view-source="Writeoff"
      :is-ar="searchConditions.isAr"
      :oversea="searchConditions.isOversea"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      :invoice-has-bill-payment="searchConditions.invoiceHasBillPayment"
      config-module="502"
      grid-config-module="190702"
      :invoice-no-state="1"
      :clearing-state="0"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-charge-count="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :always-show="false"
      :new-currency-code="true"
      :internal-charge="searchConditions.internalCharge"
      :show-wht="true"
      type="both"
      total-type="auto"
      job-state-param="WriteoffJobState"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===0 && searchConditions.writeOffMode===2"
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-invoice>
    <query-billing
      v-show="pageMode===0 && searchConditions.writeOffMode===3"
      key="queryBilling"
      ref="queryBilling"
      :is-append-query="true"
      identify="queryBillingSearchItem"
      view-source="Writeoff"
      :is-ar="searchConditions.isAr"
      :oversea="searchConditions.isOversea"
      :clearing-state="0"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      :writeoff-has-invoice="searchConditions.writeoffHasInvoice"
      :invoice-has-bill-payment="searchConditions.invoiceHasBillPayment"
      config-module="50402"
      grid-config-module="19070302"
      :show-invoice-no="true"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :internal-charge="searchConditions.internalCharge"
      :show-wht="true"
      type="both"
      total-type="auto"
      billing-state-param="WriteoffBillingState"
      billing-clearing-state-param="WriteoffBillingClearingState"
      billing-job-state-param="WriteoffJobState"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===0 && searchConditions.writeOffMode===3"
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-billing>
    <query-billing-group
      v-show="pageMode===0 && searchConditions.writeOffMode===4"
      key="queryBillingGroup"
      ref="queryBillingGroup"
      :is-append-query="true"
      identify="queryBillingGroupSearchItem"
      view-source="Writeoff"
      :is-ar="searchConditions.isAr"
      :oversea="searchConditions.isOversea"
      :clearing-state="0"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      config-module="505"
      grid-config-module="190704"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :internal-charge="searchConditions.internalCharge"
      :show-wht="true"
      type="both"
      total-type="auto"
      billing-job-state-param="WriteoffJobState"
      billing-group-state-param="WriteoffBillingGroupState"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===0 && searchConditions.writeOffMode===4"
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-billing-group>
    <query-bill-payment
      v-show="pageMode===0 && searchConditions.writeOffMode===5"
      key="queryBillPayment"
      ref="queryBillPayment"
      :is-append-query="true"
      identify="queryBillPaymentSearchItem"
      view-source="Writeoff"
      :is-ar="searchConditions.isAr"
      :paid-off="0"
      :oversea="searchConditions.isOversea"
      :state="searchConditions.state"
      :fin-approve-state="searchConditions.finApproveState"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      config-module="508"
      grid-config-module="190705"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-controlled-charge="false"
      :show-fba="false"
      :internal-charge="searchConditions.internalCharge"
      :show-wht="true"
      type="both"
      total-type="auto"
      job-state-param="WriteoffJobState"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===0 && searchConditions.writeOffMode===5"
          :page-mode="pageMode"
          :search-conditions="searchConditions"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-bill-payment>
    <!--      </div>-->
    <!-- 对冲销账 -->
    <!--      <div v-if="pageMode===1" style="display: flex;flex:1">-->
    <query-charge
      v-show="pageMode===1 && searchConditionsHedge.writeOffMode===1"
      key="queryChargeHedge"
      ref="queryChargeHedge"
      identify="queryChargeSearchItemHedge"
      view-source="Writeoff"
      :is-ar="searchConditionsHedge.isAr"
      :paid-off="searchConditionsHedge.paidOff"
      :oversea="searchConditionsHedge.isOversea"
      :input-date-start="searchConditionsHedge.inputDateStart"
      :input-date-end="searchConditionsHedge.inputDateEnd"
      :writeoff-has-invoice="searchConditionsHedge.writeoffHasInvoice"
      :invoice-has-bill-payment="searchConditionsHedge.invoiceHasBillPayment"
      :account-id="searchConditionsHedge.accountId"
      :except-advanced-search-option="searchConditionsHedge.exceptAdvancedSearchOption"
      config-module="5021"
      grid-config-module="190701"
      :show-invoice-no="true"
      :show-billing-no="true"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :internal-charge="searchConditionsHedge.internalCharge"
      type="both"
      total-type="auto"
      job-state-param="WriteoffJobState"
      charge-state-param="WriteoffChargeState"
      confirm-state-param="WriteoffChargeConfirmState"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===1 && searchConditionsHedge.writeOffMode===1"
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-charge>
    <query-invoice
      v-show="pageMode===1 && searchConditionsHedge.writeOffMode===2"
      key="queryInvoiceHedge"
      ref="queryInvoiceHedge"
      identify="queryInvoiceSearchItemHedge"
      view-source="Writeoff"
      :is-ar="searchConditionsHedge.isAr"
      :oversea="searchConditionsHedge.isOversea"
      :input-date-start="searchConditionsHedge.inputDateStart"
      :input-date-end="searchConditionsHedge.inputDateEnd"
      :account-id="searchConditionsHedge.accountId"
      :except-advanced-search-option="searchConditionsHedge.exceptAdvancedSearchOption"
      :invoice-has-bill-payment="searchConditionsHedge.invoiceHasBillPayment"
      config-module="502"
      grid-config-module="190702"
      :invoice-no-state="1"
      :clearing-state="0"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-charge-count="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :always-show="false"
      :new-currency-code="true"
      :internal-charge="searchConditionsHedge.internalCharge"
      type="both"
      total-type="auto"
      job-state-param="WriteoffJobState"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===1 && searchConditionsHedge.writeOffMode===2"
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-invoice>
    <query-billing
      v-show="pageMode===1 && searchConditionsHedge.writeOffMode===3"
      key="queryBillingHedge"
      ref="queryBillingHedge"
      identify="queryBillingSearchItemHedge"
      view-source="Writeoff"
      :is-ar="searchConditionsHedge.isAr"
      :oversea="searchConditionsHedge.isOversea"
      :clearing-state="0"
      :input-date-start="searchConditionsHedge.inputDateStart"
      :input-date-end="searchConditionsHedge.inputDateEnd"
      :writeoff-has-invoice="searchConditionsHedge.writeoffHasInvoice"
      :invoice-has-bill-payment="searchConditionsHedge.invoiceHasBillPayment"
      :account-id="searchConditionsHedge.accountId"
      :except-advanced-search-option="searchConditionsHedge.exceptAdvancedSearchOption"
      config-module="50403"
      grid-config-module="19070303"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :internal-charge="searchConditionsHedge.internalCharge"
      type="both"
      total-type="auto"
      billing-state-param="WriteoffBillingState"
      billing-clearing-state-param="WriteoffBillingClearingState"
      billing-job-state-param="WriteoffJobState"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===1 && searchConditionsHedge.writeOffMode===3"
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-billing>
    <query-billing-group
      v-show="pageMode===1 && searchConditionsHedge.writeOffMode===4"
      key="queryBillingGroupHedge"
      ref="queryBillingGroupHedge"
      identify="queryBillingGroupSearchItemHedge"
      view-source="Writeoff"
      :is-ar="searchConditionsHedge.isAr"
      :oversea="searchConditionsHedge.isOversea"
      :clearing-state="0"
      :input-date-start="searchConditionsHedge.inputDateStart"
      :input-date-end="searchConditionsHedge.inputDateEnd"
      :account-id="searchConditionsHedge.accountId"
      :except-advanced-search-option="searchConditionsHedge.exceptAdvancedSearchOption"
      config-module="505"
      grid-config-module="190704"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-fba="false"
      :internal-charge="searchConditionsHedge.internalCharge"
      type="both"
      total-type="auto"
      billing-job-state-param="WriteoffJobState"
      billing-group-state-param="WriteoffBillingGroupState"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===1 && searchConditionsHedge.writeOffMode===4"
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-billing-group>
    <query-bill-payment
      v-show="pageMode===1 && searchConditionsHedge.writeOffMode===5"
      key="queryBillPaymentHedge"
      ref="queryBillPaymentHedge"
      identify="queryBillPaymentSearchItemHedge"
      view-source="Writeoff"
      :is-ar="searchConditionsHedge.isAr"
      :paid-off="0"
      :oversea="searchConditionsHedge.isOversea"
      :state="searchConditionsHedge.state"
      :fin-approve-state="searchConditionsHedge.finApproveState"
      :input-date-start="searchConditionsHedge.inputDateStart"
      :input-date-end="searchConditionsHedge.inputDateEnd"
      :account-id="searchConditionsHedge.accountId"
      :except-advanced-search-option="searchConditionsHedge.exceptAdvancedSearchOption"
      config-module="508"
      grid-config-module="190705"
      :show-real-clearing-state="true"
      :show-total-unverified-amount="true"
      :show-unverified-amount="true"
      :show-controlled-charge="false"
      :show-fba="false"
      :internal-charge="searchConditionsHedge.internalCharge"
      type="both"
      total-type="auto"
      job-state-param="WriteoffJobState"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <writeoff-operations
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          @toChangePage="toChangePage"
          @toHedgeWriteOff="toHedgeWriteOff"
          @toWriteOff="toWriteOff"
          @toActualPayment="toActualPayment"
        />
      </div>
      <template v-slot:searchAreaHeader>
        <writeoff-search-area-header
          v-if="pageMode===1 && searchConditionsHedge.writeOffMode===5"
          :page-mode="pageMode"
          :search-conditions="searchConditionsHedge"
          :write-off-privilege="writeOffPrivilege"
        />
      </template>
    </query-bill-payment>
    <!--      </div>-->
    <!--    </div>-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!-- 销账 or 对冲销账 -->
    <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteoff" :location="location" :visible.sync="writeOffDialog.visible" :title="title" :params="writeOffDialog.params" :properties="this.properties" view-source="tabNonWriteOffList" :finance-charge-share-modify="financeChargeShareModify" @writeoffSuccessHandler="writeoffSuccessHandler" />
    <!-- 选择实收实付记录 弹窗 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="realSendReceiveDialog.visible"
      :title="$t('WriteOff.selectActualReceiptAndPayment')"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="app-main-content"
    >
      <write-off-search
        v-if="realSendReceiveDialog.visible"
        ref="searchItem"
        config-module="510"
        grid-config-module="191002"
        :is-prepay="1"
        :is-real-send-receive="true"
        :show-simple="false"
        :remain-condition="true"
        dialog-height="height: 500px;"
        :is-dialog="true"
        row-selection-type="single"
        @clickedCallBack="row => realSendReceiveDialog.dialogClickRow = row"
      />
      <div slot="footer">
        <el-button type="primary" no="1" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="2" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import writeOffSearch from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffSearch'
import { DocumentManage } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import writeOffDialog from './writeOffDialog'
import moment from 'moment'
import { cacheName, cache } from '@/utils/cacheManager'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'

import QueryCharge from '@/views/cargo/v0/Clearing/components/query/queryCharge'
import QueryInvoice from '@/views/cargo/v0/Clearing/components/query/queryInvoice'
import QueryBilling from '@/views/cargo/v0/Clearing/components/query/queryBilling'
import QueryBillingGroup from '@/views/cargo/v0/Clearing/components/query/queryBillingGroup'
import QueryBillPayment from '@/views/cargo/v0/Clearing/components/query/queryBillPayment'
import WriteoffOperations from '@/views/cargo/v0/Clearing/components/Writeoff/writeoffOperations'
import WriteoffSearchAreaHeader from '@/views/cargo/v0/Clearing/components/Writeoff/writeoffSearchAreaHeader'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE, LOG_WRITE_OFF } from '@/class/cargo/model/parameters/SystemConstants'
import microApp from '@micro-zoe/micro-app'

export default {
  name: 'TabNonWriteOffList',
  components: { searchItem, cargoTemplateSelectorDialog, writeOffSearch, writeOffDialog, QueryCharge, QueryInvoice, QueryBilling, QueryBillingGroup, QueryBillPayment, WriteoffOperations, WriteoffSearchAreaHeader },
  data() {
    return {
      documentManage: new DocumentManage(),
      loading: false,
      /**
       * 页面模式: 0-未销账列表 1-销账列表
       */
      pageMode: 0,
      searchConditions: {
        isAr: 1, // 收付方式: 全部、应收、应付
        isOversea: 0, // 费用类型: 国内、国外
        paidOff: 0, // 是否销账
        writeOffMode: 2, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 业务日期
        inputDateEnd: '',
        allowWriteoffQueryAll: false, // AllowWriteoffQueryAll, 销账允许查询全部
        writeoffHasInvoice: -1, // WriteoffHasInvoice, 销账-是否已开票(销账)
        invoiceHasBillPayment: -1, // InvoiceHasBillPayment, 是否已申请付款(销账)
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        accountId: 0, // 默认结算单位
        rbArEnabled: true, // 应收按钮
        rbApEnabled: true, // 应付按钮
        internalCharge: false, // 内结
        state: [10],
        finApproveState: [1]
      },
      searchConditionsHedge: {
        isAr: 1, // 收付方式: 全部、应收、应付
        isOversea: 0, // 费用类型: 国内、国外
        paidOff: 0, // 是否销账
        writeOffMode: 2, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 业务日期
        inputDateEnd: '',
        allowWriteoffQueryAll: false, // AllowWriteoffQueryAll, 销账允许查询全部
        writeoffHasInvoice: -1, // WriteoffHasInvoice, 销账-是否已开票(销账)
        invoiceHasBillPayment: -1, // InvoiceHasBillPayment, 是否已申请付款(销账)
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        accountId: 0, // 默认结算单位
        rbArEnabled: true, // 应收按钮
        rbApEnabled: true, // 应付按钮
        exceptKeys: [], // 对冲开票/销账时，排除费用
        exceptAdvancedSearchOption: null,
        internalCharge: false, // 内结
        state: [10],
        finApproveState: [1]
      },
      writeOffPrivilege: {
        chargeAr: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByChargeAr']),
        chargeAp: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByChargeAp']),
        invoiceAr: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByInvoiceAr']),
        invoiceAp: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByInvoiceAp']),
        billingAr: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByBillingAr']),
        billingAp: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByBillingAp']),
        billingGroupAr: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByBillingGroupAr']),
        billingGroupAp: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByBillingGroupAp']),
        billPayment: this.$store.getters.isAdmin || this.$checkPermission(['tab_ACWriteoff_writeoffByPayment'])
      },
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: false, // 是否海外销账
        defaultCurrency: 'RMB', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: 0, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: false, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        openHecConfig: false,
        writeOffFinanceChargeShareJob: false, // 销账时财务费用是否分摊到业务
        prePaymentVerifyCanMultiCurrency: false, // 预收付款核销支持多币种
        kartenNumberRule: false, // 嘉腾定制规则：销账备注生成流水单号
        writeOffRemarkShowSrialNo: '', // 应收销账备注生成流水号。0=不开启；1=按“${office}${YY}${MM}${SSSS:OM}”规则；2=按“${office}${YY}${MM}${SSSS:OM}${payDate}规则”
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [], // 费用所包含的币种
        otherCurrencyRate: [], // 其它币种和汇率
        actualAmounts: [], // 使用多了实收实付记录进行销账
        jydToFinanceApi: false // 集翊达用友U8CLOUD
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      writeOffDialog: {
        visible: false,
        params: {}
      },
      realSendReceiveDialog: {
        visible: false,
        params: null,
        dialogClickRow: null // 新增实收实付中选中的行
      },
      location: LOG_WRITE_OFF.code,
      financeChargeShareModifyData: { // 子应用财务费用分摊固定费用名称、结算对象、收付类型
        viewSource: 'WriteOff',
        notModify: false
      },
      financeChargeShareModify: false
    }
  },
  computed: {
    totalDetailExpandClass() {
      return { 'el-icon-d-arrow-left': this.totalDetailDialog.visible, 'el-icon-d-arrow-right': !this.totalDetailDialog.visible, 'el-icon--right': true }
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    },
    // 是否有应收权限
    writeOffPrivilegeAr() {
      return this.writeOffPrivilege.chargeAr || this.writeOffPrivilege.invoiceAr || this.writeOffPrivilege.billingAr || this.writeOffPrivilege.billingGroupAr
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initConfig()
  },
  mounted() {
    this.scrollCallback()
    document.querySelector('.parent-wrapper').addEventListener('scroll', this.scrollCallback)
    // this.fetchData()
  },
  methods: {
    // 配置参数
    initConfig() {
      this.searchConditions.allowWriteoffQueryAll = Number(cache.config.get('AllowWriteoffQueryAll')) === 1
      this.searchConditions.writeoffHasInvoice = Number(cache.config.get('WriteoffHasInvoice'))
      this.searchConditions.invoiceHasBillPayment = Number(cache.config.get('InvoiceHasBillPayment'))
      this.properties.isExt = Number(cache.config.get('ext')) === 1
      this.properties.writeoffByDifferentAccount = Number(cache.config.get('WriteoffByDifferentAccount')) === 1
      this.properties.writeoffCheckBillpaymentDone = Number(cache.config.get('WriteoffCheckBillpaymentDone')) === 1
      this.properties.mustUseActualAmountWriteoff = Number(cache.config.get('MustUseActualAmountWriteoff')) === 1
      this.properties.isHQWriteoffConfirm = Number(cache.config.get('isHQWriteoffConfirm')) === 1
      this.properties.isWriteoffCurrencyByInvoice = Number(cache.config.get('isWriteoffCurrencyByInvoice')) === 1
      this.properties.payAfterPayApply = Number(cache.config.get('PayAfterPayApply'))
      this.properties.openHecConfig = Number(cache.config.get('openHecConfig')) === 1
      this.properties.writeOffFinanceChargeShareJob = Number(cache.config.get('WriteOffFinanceChargeShareJob')) === 1
      this.properties.prePaymentVerifyCanMultiCurrency = Number(cache.config.get('PrePaymentVerifyCanMultiCurrency')) === 1
      this.properties.kartenNumberRule = Number(cache.config.get('KartenNumberRule')) === 1
      this.properties.writeOffRemarkShowSrialNo = cache.config.get('WriteOffRemarkShowSrialNo') !== '0'
      this.properties.jydToFinanceApi = cache.config.get('ToFinanceApi') === 'JYDYY' // 集翊达用友U8CLOUD

      this.searchConditions.isAr = this.searchConditions.allowWriteoffQueryAll ? -1 : (this.writeOffPrivilegeAr ? 1 : 0)

      // CARGO-41429 开启配置WriteoffCheckBillpaymentDone=0时，效果没有实现，销帐查询模块查询不到所有付款申请单
      if (!this.properties.writeoffCheckBillpaymentDone) {
        this.searchConditions.state = []
        this.searchConditions.finApproveState = []
        this.searchConditionsHedge.state = []
        this.searchConditionsHedge.finApproveState = []
      }
    },
    // todo: 请注意，该页表格列根据搜索条件切换，获取gridOptions请使用this.getGridOptions()，赋值表格数据请单独加判断
    fetchData() {
      // todo 加载列表数据
      const rowData = [
        {
          jobNo: 'SHSE20015062', path: 'SHSE20015062'
        },
        {
          jobNo: 'SHSE200150001', path: 'SHSE20015062, SHSE200150001'
        }
      ]
      switch (this.searchConditions.writeOffMode) {
        case 1: this.chargeGrid.rowData = rowData
          break
        case 2: this.invoiceGrid.rowData = rowData
          break
        case 3: this.billingGrid = rowData
          break
        case 4: this.billingGroupGrid.rowData = rowData
          break
        case 5: this.paymentsGrid.rowData = rowData
          break
      }
      // fixme: 方便测试，全部添加假数据
      this.chargeGrid.rowData = rowData
      this.invoiceGrid.rowData = rowData
      this.billingGrid = rowData
      this.billingGroupGrid.rowData = rowData
      this.paymentsGrid.rowData = rowData
    },
    toChangePage() {
      // 跳转到对冲销账模式页面时，需选择至少一条数据
      if (this.pageMode === 0) {
        this.properties.selectedEntities = getGridSelected(this.getGridOptions())
        if (this.properties.selectedEntities.length === 0) {
          switch (this.searchConditions.writeOffMode) {
            case 1: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
              break
            case 2: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
              break
            case 3: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
              break
            case 4: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
              break
            case 5: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
              break
          }
          return
        }
        if (!ClearingUtils.isSameAccount(this.properties.selectedEntities)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SettlingCompanyMustBeIdentical'))
          return
        }
        this.properties.accountId = this.properties.selectedEntities[0].accountId
        //
        if (this.searchConditions.isAr === -1) {
          this.searchConditionsHedge.isAr = this.searchConditions.isAr
        } else if (this.searchConditions.isAr === 1) {
          this.searchConditionsHedge.isAr = 0
        } else {
          this.searchConditionsHedge.isAr = 1
        }
        this.searchConditionsHedge.isOversea = this.searchConditions.isOversea
        this.searchConditionsHedge.paidOff = this.searchConditions.paidOff
        this.searchConditionsHedge.writeOffMode = this.searchConditions.writeOffMode
        this.searchConditionsHedge.inputDateStart = this.searchConditions.inputDateStart
        this.searchConditionsHedge.inputDateEnd = this.searchConditions.inputDateEnd
        this.searchConditionsHedge.allowWriteoffQueryAll = this.searchConditions.allowWriteoffQueryAll
        this.searchConditionsHedge.writeoffHasInvoice = this.searchConditions.writeoffHasInvoice
        this.searchConditionsHedge.invoiceHasBillPayment = this.searchConditions.invoiceHasBillPayment
        this.searchConditionsHedge.rpDate = this.searchConditions.rpDate
        this.searchConditionsHedge.accountId = this.properties.accountId
        this.searchConditionsHedge.rbArEnabled = this.searchConditionsHedge.isAr === 0
        this.searchConditionsHedge.rbApEnabled = this.searchConditionsHedge.isAr === 1
        this.getExceptKeys()
        this.pageMode = 1
        if (!this.properties.writeoffCheckBillpaymentDone) {
          this.searchConditionsHedge.state = []
          this.searchConditionsHedge.finApproveState = []
        }

        // const self = this
        // getGridSelectedIds(this.getGridOptions()).then(ids => {
        //   if (ids.length < 1) {
        //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
        //   } else {
        //     // eslint-disable-next-line no-unused-vars
        //     const rowData = getGridSelected(this.getGridOptions())[0]
        //     this.pageMode = 1
        //   }
        // })
      } else {
        this.pageMode = 0
      }
    },
    toHedgeWriteOff() {
      this.properties.selectedEntitiesHedge = getGridSelected(this.getGridOptions())
      if (this.properties.selectedEntitiesHedge.length === 0) {
        switch (this.searchConditionsHedge.writeOffMode) {
          case 1: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
            break
          case 2: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
            break
          case 3: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
            break
          case 4: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
            break
          case 5: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
            break
        }
        return
      }
      if (this.queryOfficeId() !== this.$store.getters.currentOfficeId || this.queryOfficeId(true) !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      if (!ClearingUtils.isSameAccount(this.properties.selectedEntitiesHedge)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingCompanyMustBeIdentical'))
        return
      }
      this.hedgeWriteoffHandler()

      // const self = this
      // getGridSelectedIds(this.getGridOptions()).then(ids => {
      //   if (ids.length < 1) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // eslint-disable-next-line no-unused-vars
      //     const rowData = getGridSelected(this.getGridOptions())[0]
      //     this.writeOffDialog.visible = true
      //     this.writeOffDialog.title = '对冲销账-XXX'
      //     this.writeOffDialog.params = {
      //       // 对冲销账模式
      //       mode: 1,
      //       // 该条件值this.searchConditions.writeOffMode[this.searchConditions.writeOffMode]需另存变量
      //       writeOffMode: this.searchConditions.writeOffMode,
      //       // 对冲核销下的选项
      //       hedgeWriteOffMode: this.searchConditions.writeOffMode
      //     }
      //   }
      // })
    },
    toWriteOff() {
      this.properties.selectedEntities = getGridSelected(this.getGridOptions())
      if (this.properties.selectedEntities.length === 0) {
        switch (this.searchConditions.writeOffMode) {
          case 1: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
            break
          case 2: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
            break
          case 3: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
            break
          case 4: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
            break
          case 5: this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
            break
        }
        return
      }
      if (this.queryOfficeId() !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      // 按费用销账增加判断校验
      if (this.searchConditions.writeOffMode === 1) {
        let isSame = true
        let isOversea = null
        for (const item of this.properties.selectedEntities) {
          if (isOversea === null) {
            isOversea = item.isOversea
          } else if (isOversea !== item.isOversea) {
            isSame = false
            break
          }
        }
        if (!isSame) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanNotWriteOffForDifferentExpenseTypes'))
          return
        }
      }
      if (this.properties.writeoffByDifferentAccount) {
        if (!ClearingUtils.isSameAccount(this.properties.selectedEntities)) {
          this.$confirm(this.$t('CargoMsg.Cargo_FIDSEC'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            type: 'warning'
          }).then(() => {
            this.properties.accountId = 0
            this.writeoffHandler()
          }).catch(() => {
            //
          })
        } else {
          this.properties.accountId = this.properties.selectedEntities[0].accountId
          this.writeoffHandler()
        }
      } else {
        if (this.properties.jydToFinanceApi) {
          let compareField = 'title'
          switch (this.searchConditions.writeOffMode) {
            case 1: compareField = 'invoiceTitle'
              break
            case 5: compareField = 'billPaymentInvoiceTitle'
              break
            default: compareField = 'title'
              break
          }
          if (!ClearingUtils.isSameInvoiceTitle(this.properties.selectedEntities, compareField)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceTitleMustBeIdentical'))
            return
          }
        }
        if (!ClearingUtils.isSameAccount(this.properties.selectedEntities)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SettlingCompanyMustBeIdentical'))
          return
        }
        this.properties.accountId = this.properties.selectedEntities[0].accountId
        this.writeoffHandler()
      }

      // const self = this
      // getGridSelectedIds(this.getGridOptions()).then(ids => {
      //   if (ids.length < 1) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // eslint-disable-next-line no-unused-vars
      //     const rowData = getGridSelected(this.getGridOptions())[0]
      //     this.writeOffDialog.visible = true
      //     // todo: 根据结算对象拼接title
      //     this.writeOffDialog.title = '销账-XXX'
      //     this.writeOffDialog.params = {
      //       // 销账模式
      //       mode: 0,
      //       // 该条件值this.searchConditions.writeOffMode[this.searchConditions.writeOffMode]需另存变量
      //       writeOffMode: this.searchConditions.writeOffMode
      //     }
      //   }
      // })
    },
    // 销账
    writeoffHandler() {
      // if (this.properties.actualAmount && this.properties.actualAmount.accountId) {
      //   for (const obj of this.properties.selectedEntities) {
      //     if (obj.hasOwnProperty('accountId') && this.properties.actualAmount.accountId !== obj.accountId) {
      //       this.$message.warning('选择的实收/实付结算单位必须相同！')
      //       return
      //     }
      //   }
      // }
      this.properties.isHedge = false
      this.initEntities()
    },
    // 对冲销账
    hedgeWriteoffHandler() {
      this.properties.isHedge = true
      this.initEntities()
    },
    async initEntities() {
      console.log('initEntities')
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      this.properties.selectedEntitiesOrigin = this.properties.selectedEntities
      this.getIsAr()
      this.getIsOversea()
      if (this.realSendReceiveDialog && this.realSendReceiveDialog.dialogClickRow) {
        this.properties.actualAmount = this.realSendReceiveDialog.dialogClickRow
        this.realSendReceiveDialog.dialogClickRow = null
      } else {
        this.properties.actualAmount = null
      }
      this.properties.writeOffMode = this.searchConditions.writeOffMode
      this.properties.rpDate = this.searchConditions.rpDate
      this.properties.entities = []
      const keys = []
      for (const item of this.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'classType': this.classType(false), 'isOversea': this.properties.isOversea, 'officeId': this.$store.getters.currentOfficeId }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToWriteOff'))
        return
      }
      // 按费用销账：组合列表
      if (this.searchConditions.writeOffMode === 1) {
        // 参照 WriteoffManager.groupWriteoff、groupWriteoffByAccountId
        this.properties.chargeAccountIds = []
        const selectedEntitiesNew = []
        for (const charge of this.properties.selectedEntities) {
          if (this.properties.chargeAccountIds.indexOf(charge.accountId) === -1) {
            this.properties.chargeAccountIds.push(charge.accountId)
            selectedEntitiesNew.push(charge)
          }
        }
        this.properties.selectedEntities = selectedEntitiesNew
      }
      // 对冲销账
      this.properties.hedgeEntities = [] // 重置
      if (this.properties.isHedge) {
        await this.initEntitiesHedge()
        if (this.properties.hedgeEntities.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToWriteOff'))
          return
        }
        // 按费用销账：组合列表
        if (this.searchConditionsHedge.writeOffMode === 1) {
          this.properties.hedgeChargeAccountIds = []
          const selectedEntitiesNew = []
          for (const charge of this.properties.selectedEntitiesHedge) {
            if (this.properties.hedgeChargeAccountIds.indexOf(charge.accountId) === -1) {
              this.properties.hedgeChargeAccountIds.push(charge.accountId)
              selectedEntitiesNew.push(charge)
            }
          }
          this.properties.selectedEntitiesHedge = selectedEntitiesNew
        }
        // 应收的放上面 (参照WriteoffGridView.groupingInvoice)
        if (!this.properties.isEntitiesAr) {
          const selectedEntities = this.properties.selectedEntities
          const writeOffMode = this.properties.writeOffMode
          const entities = this.properties.entities
          const isEntitiesAr = this.properties.isEntitiesAr
          const selectedEntitiesHedge = this.properties.selectedEntitiesHedge
          const writeOffModeHedge = this.properties.writeOffModeHedge
          const hedgeEntities = this.properties.hedgeEntities
          const isHedgeEntitiesAr = this.properties.isHedgeEntitiesAr
          this.properties.selectedEntities = []
          this.properties.entities = []
          this.properties.selectedEntitiesHedge = []
          this.properties.hedgeEntities = []
          this.properties.selectedEntities = selectedEntitiesHedge
          this.properties.writeOffMode = writeOffModeHedge
          this.properties.entities = hedgeEntities
          this.properties.isEntitiesAr = isHedgeEntitiesAr
          this.properties.selectedEntitiesHedge = selectedEntities
          this.properties.writeOffModeHedge = writeOffMode
          this.properties.hedgeEntities = entities
          this.properties.isHedgeEntitiesAr = isEntitiesAr
        }
        await this.refreshEntitiesIsHedge()
      }
      //
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      this.properties.allEntities.push(...this.properties.hedgeEntities)
      //
      this.properties.currencys = []
      if (this.properties.actualAmount) {
        for (const charge of this.properties.allEntities) {
          if (this.properties.actualAmount.accountId && charge.accountId && this.properties.actualAmount.accountId !== charge.accountId) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SAPPMBI'))
            return
          }
        }
      }
      for (const charge of this.properties.allEntities) {
        if (this.properties.currencys.indexOf(charge.currency) === -1) {
          this.properties.currencys.push(charge.currency)
        }
      }
      //
      if (this.checking()) {
        this.writeOffDialog.visible = true
      }
    },
    async initEntitiesHedge() {
      console.log('initEntitiesHedge')
      if (!this.properties.isHedge) return
      if (this.properties.selectedEntitiesHedge.length === 0) {
        return
      }
      this.getIsAr(true)
      this.getIsOversea(true)
      this.properties.writeOffModeHedge = this.searchConditionsHedge.writeOffMode
      this.properties.rpDate = this.searchConditionsHedge.rpDate
      this.properties.hedgeEntities = []
      const keys = []
      for (const item of this.properties.selectedEntitiesHedge) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'classType': this.classType(true), 'isOversea': this.properties.isOversea, 'officeId': this.$store.getters.currentOfficeId }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.hedgeEntities = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    toActualPayment() {
      this.realSendReceiveDialog.visible = true
      this.realSendReceiveDialog.dialogClickRow = null
    },
    selectedActualPayment(data) {},
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      console.log('toSearchTemplate', value)
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.cxt = {} // Job.queryJobLink 没有迁移过来
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    },
    // 构建对冲销账页面提示语(切换到对冲销账页面模式才使用,根据原始销账页面选择的销账模式拼接)
    buildTitle() {
      let tip = this.$t('Clearing.OffsetSearchAndSelectThe')
      // todo: fixme: 应设置单独变量存放销账模式页面下的变量值(在获取数据后更新)，并用于此处
      switch (this.searchConditions.writeOffMode) {
        case 1: tip += this.$t('SeaExport.Charge')
          break
        case 2: tip += this.$t('Clearing.Invoices')
          break
        case 3: tip += this.$t('Clearing.Statements')
          break
        case 4: tip += this.$t('Clearing.AccountStatements')
          break
        case 5: tip += this.$t('Clearing.PaymentApplications')
          break
      }
      return tip
    },
    // 获取cargo-ag-grid表格组件的gridOptions
    getGridOptions() {
      const writeOffMode = this.pageMode === 0 ? this.searchConditions.writeOffMode : this.searchConditionsHedge.writeOffMode
      let gridOptions
      switch (writeOffMode) {
        case 1: gridOptions = this.pageMode === 0 ? this.$refs.queryCharge.chargeGrid.gridOptions : this.$refs.queryChargeHedge.chargeGrid.gridOptions
          break
        case 2: gridOptions = this.pageMode === 0 ? this.$refs.queryInvoice.gridOptions : this.$refs.queryInvoiceHedge.gridOptions
          break
        case 3: gridOptions = this.pageMode === 0 ? this.$refs.queryBilling.gridOptions : this.$refs.queryBillingHedge.gridOptions
          break
        case 4: gridOptions = this.pageMode === 0 ? this.$refs.queryBillingGroup.gridOptions : this.$refs.queryBillingGroupHedge.gridOptions
          break
        case 5: gridOptions = this.pageMode === 0 ? this.$refs.queryBillPayment.billPaymentGrid.gridOptions : this.$refs.queryBillPaymentHedge.billPaymentGrid.gridOptions
          break
      }
      return gridOptions
    },
    // 参照cargoware：如果行类型Charge/IWriteoffable，根据第一条记录
    getIsAr(isHedge = false) {
      const searchConditions = !isHedge ? this.searchConditions : this.searchConditionsHedge
      this.properties.isAr = searchConditions.isAr === 1
      switch (searchConditions.writeOffMode) {
        case 1: this.properties.isAr = !isHedge ? this.properties.selectedEntities[0].isReceivable : this.properties.selectedEntitiesHedge[0].isReceivable
          break
        case 2: this.properties.isAr = !isHedge ? this.properties.selectedEntities[0].isAr : this.properties.selectedEntitiesHedge[0].isAr
          break
        case 3: this.properties.isAr = !isHedge ? this.properties.selectedEntities[0].ar : this.properties.selectedEntitiesHedge[0].ar
          break
        case 4: this.properties.isAr = !isHedge ? this.properties.selectedEntities[0].ar : this.properties.selectedEntitiesHedge[0].ar
          break
        case 5: this.properties.isAr = !isHedge ? this.properties.selectedEntities[0].ar : this.properties.selectedEntitiesHedge[0].ar
          break
      }
      if (!isHedge) {
        this.properties.isEntitiesAr = this.properties.isAr
      } else {
        this.properties.isHedgeEntitiesAr = this.properties.isAr
      }
    },
    // 参照cargoware：conditionIsOversea
    getIsOversea(isHedge = false) {
      this.properties.isOversea = false
      if (!isHedge && this.properties.isExt) {
        if ([2, 5].includes(this.searchConditions.writeOffMode)) {
          this.properties.isOversea = false
        } else {
          this.properties.isOversea = (this.searchConditions.isOversea === 1)
        }
      }
    },
    // 参照 ActualAmount.checkBillPaymentApproved
    checking() {
      if (this.properties.payAfterPayApply === 1 || this.properties.payAfterPayApply === 2 || this.properties.payAfterPayApply === 3) {
        if (this.properties.payAfterPayApply === 2) {
          const allAr = this.checkAllReceivable(this.properties.selectedEntities, this.properties.writeOffMode)
          const writeOffMode = this.properties.isHedge ? this.properties.writeOffModeHedge : this.properties.writeOffMode
          if (allAr && [2, 3, 4].includes(writeOffMode)) {
            return true
          }
        }
        for (const charge of this.properties.entities) {
          if (this.properties.payAfterPayApply === 3) {
            if (!charge.isReceivable && (charge.billPaymentUuid && [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail2'))
              return false
            }
          } else {
            if (!charge.isReceivable && (StrUtils.isEmpty(charge.billPaymentUuid) || [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail'))
              return false
            }
          }
        }
      } else if (this.properties.writeoffCheckBillpaymentDone && this.properties.writeOffMode === 5) {
        for (const charge of this.properties.entities) {
          if (Math.abs(charge.currentVerifiedAmount) >= 0.005 && !charge.isPaidOff && !StrUtils.isEmpty(charge.billPaymentUuid) && [0, 1, 2, 6, 9].includes(charge.billPaymentState)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OFAOPOTFSIITPRPPDNOATRIC_Payment'))
            return false
          }
        }
      }
      return true
    },
    checkAllReceivable(rows, writeOffMode) {
      let field = ''
      switch (writeOffMode) {
        case 1:
          field = 'isReceivable'
          break
        case 2:
          field = 'isAr'
          break
        case 3:
        case 4:
        case 5:
          field = 'ar'
          break
      }
      for (const row of rows) {
        if (!row[field]) {
          return false
        }
      }
      return true
    },
    writeoffSuccessHandler(data) {
      console.log('writeoffSuccessHandler:', data)
      this.pageMode = 0
      // 列表刷新
      this.getGridOptions().api.updateRowData({ remove: this.properties.selectedEntitiesOrigin })
      // 刷新条数
      switch (this.searchConditions.writeOffMode) {
        case 1: this.$refs.queryCharge.updateRealtotal(this.$refs.queryCharge.searchConditions.totalChargeGrid - this.properties.selectedEntitiesOrigin.length)
          break
        case 2: this.$refs.queryInvoice.updateRealtotal(this.$refs.queryInvoice.searchConditions.total - this.properties.selectedEntitiesOrigin.length)
          break
        case 3: this.$refs.queryBilling.updateRealtotal(this.$refs.queryBilling.searchConditions.total - this.properties.selectedEntitiesOrigin.length)
          break
        case 4: this.$refs.queryBillingGroup.updateRealtotal(this.$refs.queryBillingGroup.searchConditions.total - this.properties.selectedEntitiesOrigin.length)
          break
        case 5: this.$refs.queryBillPayment.updateRealtotal(this.$refs.queryBillPayment.searchConditions.total - this.properties.selectedEntitiesOrigin.length)
          break
      }
    },
    classType(isHedge = false) {
      const searchConditions = !isHedge ? this.searchConditions : this.searchConditionsHedge
      switch (searchConditions.writeOffMode) {
        case 1: return 'charge'
          break
        case 2: return 'invoice'
          break
        case 3: return 'billing'
          break
        case 4: return 'billingGroup'
          break
        case 5: return 'billPayment'
          break
      }
    },
    // 对冲开票/销账时排除费用
    getExceptKeys() {
      console.log('getExceptKeys')
      const keys = []
      for (const item of this.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      this.searchConditionsHedge.exceptKeys = keys
      let option = null
      switch (this.searchConditions.writeOffMode) {
        case 1: option = new AdvancedSearchOption(null, 'charge.UUID', this.searchConditionsHedge.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
          break
        case 2: option = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', this.searchConditionsHedge.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
          break
        case 3: option = new AdvancedSearchOption(null, 'charge.BILLING_UUID', this.searchConditionsHedge.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
          break
        case 4: option = new AdvancedSearchOption(null, 'billing.BILLING_GROUP_UUID', this.searchConditionsHedge.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
          break
        case 5: option = new AdvancedSearchOption(null, 'charge.BILL_PAYMENT_UUID', this.searchConditionsHedge.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
          break
      }
      this.searchConditionsHedge.exceptAdvancedSearchOption = option
    },
    scrollCallback() {
      console.log('scrollCallback')
      const writeOffMode = this.pageMode === 0 ? this.searchConditions.writeOffMode : this.searchConditionsHedge.writeOffMode
      switch (writeOffMode) {
        case 1: this.pageMode === 0 ? this.$refs.queryCharge.scrollCallback() : this.$refs.queryChargeHedge.scrollCallback()
          break
        case 2: this.pageMode === 0 ? this.$refs.queryInvoice.scrollCallback() : this.$refs.queryInvoiceHedge.scrollCallback()
          break
        case 3: this.pageMode === 0 ? this.$refs.queryBilling.scrollCallback() : this.$refs.queryBillingHedge.scrollCallback()
          break
        case 4: this.pageMode === 0 ? this.$refs.queryBillingGroup.scrollCallback() : this.$refs.queryBillingGroupHedge.scrollCallback()
          break
        case 5: this.pageMode === 0 ? this.$refs.queryBillPayment.scrollCallback() : this.$refs.queryBillPaymentHedge.scrollCallback()
          break
      }
    },
    // 选择实收实付 确定按钮事件
    enterHandler() {
      // if (!this.realSendReceiveDialog.dialogClickRow) {
      //   this.$message.info('请选择实收实付.')
      //   return
      // }
      // // todo 数据处理
      // const actualAmount = this.realSendReceiveDialog.dialogClickRow
      // console.log(actualAmount)
      // this.cancelHandler()
      this.realSendReceiveDialog.visible = false
    },
    // 选择实收实付 取消按钮事件
    cancelHandler() {
      this.realSendReceiveDialog.dialogClickRow = null
      this.realSendReceiveDialog.visible = false
    },
    // 对冲销账：根据费用的结算对象分开显示
    refreshEntitiesIsHedge() {
      if (this.properties.isHedge) {
        if (this.properties.writeOffMode === 1) {
          for (const charge of this.properties.entities) {
            charge.isHedge = false
          }
        }
        if (this.properties.writeOffModeHedge === 1) {
          for (const charge of this.properties.hedgeEntities) {
            charge.isHedge = true
          }
        }
      }
    },
    // 查询时的分公司Id
    queryOfficeId(isHedge = false) {
      const writeOffMode = !isHedge ? this.searchConditions.writeOffMode : this.searchConditionsHedge.writeOffMode
      switch (writeOffMode) {
        case 1: return !isHedge ? this.$refs.queryCharge.queryOfficeId : this.$refs.queryChargeHedge.queryOfficeId
          break
        case 2: return !isHedge ? this.$refs.queryInvoice.queryOfficeId : this.$refs.queryInvoiceHedge.queryOfficeId
          break
        case 3: return !isHedge ? this.$refs.queryBilling.queryOfficeId : this.$refs.queryBillingHedge.queryOfficeId
          break
        case 4: return !isHedge ? this.$refs.queryBillingGroup.queryOfficeId : this.$refs.queryBillingGroupHedge.queryOfficeId
          break
        case 5: return !isHedge ? this.$refs.queryBillPayment.queryOfficeId : this.$refs.queryBillPaymentHedge.queryOfficeId
          break
      }
    },
    setFinanceChargeShareModifyData() {
      console.log('主应用发送FinanceChargeShareModify:', this.financeChargeShareModifyData)
      microApp.forceSetData('child-finance-charge-share-modify', this.financeChargeShareModifyData)
    },
    financeChargeShareModifyDataChange(e) {
      console.log('主应用获取FinanceChargeShareModify:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setFinanceChargeShareModifyData()
        } else {
          this.financeChargeShareModify = e.detail.data.notModify
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .footer-wrapper {
    align-items: center;
    .fixedBottom {
      position: fixed;
      bottom: 0;
      right: 15px;
      background: #fff;
    }
  }
</style>
